import React from 'react';
import './FlipCard.css';

interface FlipCardProps {
  /** When true, card is flipped to show back */
  flipped: boolean;
  /** When true, back is fading out (e.g. before next question) */
  isFadingOut: boolean;
  /** Front face content */
  front: React.ReactNode;
  /** Back face content - when null, back is not rendered */
  back: React.ReactNode | null;
  className?: string;
}

/**
 * Reusable flip card with same animation and timing as QuestionDisplay.
 * Uses 0.4s flip transition, 0.8s when flipping to back.
 */
export const FlipCard: React.FC<FlipCardProps> = ({
  flipped,
  isFadingOut,
  front,
  back,
  className = '',
}) => {
  return (
    <div className={`flip-card-container ${className}`}>
      <div
        className={`flip-card ${flipped ? 'flip-card--flipped' : ''}`}
      >
        <div className={`flip-card__front ${flipped ? 'flip-card__front--hidden' : ''}`}>
          {front}
        </div>
        {back !== null && (
          <div className={`flip-card__back ${isFadingOut ? 'flip-card__back--fading' : ''}`}>
            {back}
          </div>
        )}
      </div>
    </div>
  );
};
